import { createAsyncThunk } from '@reduxjs/toolkit';
import { updatePrivacySettings } from '../../../common/api';

export const saveGdprOption = createAsyncThunk('save-gdpr-option', async () => {
  const result = await updatePrivacySettings({ customsLink: true });
  return result.success;
});
